import React from "react";
import { View, Text } from "react-native";
import { LeaderboardState, LeaderboardActions } from "../controllers/LeaderboardController";
import { Option } from "react-dropdown";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { CountDownTimer } from "../components/textcontainers/CountDownTimer";
import { LeaderboardDropdown } from "../components/leaderboard/LeaderboardDropdown";
import { GlobalStyles } from "../components/style/Style";
import { Leaderboard } from "../components/leaderboard/Leaderboard";
import { useServices } from "../contexts/ServiceContext";
import { MediaQueries } from "../components/hooks/dynamicStyleHook";
import { BettingEventStatus } from "@freeplay/shared-code";

export interface GameViewProps {
    /**
     * Used to id this component during testing.
     */
    testID?: string;

    state: LeaderboardState;
    dispatch: React.Dispatch<LeaderboardActions>;
    handleEventSelected: (arg: Option) => void;
}
export const LeaderboardView: React.FC<GameViewProps> = ({ testID, state, handleEventSelected }) => {
    const { edgeDeploy } = useServices();
    const { leaderboardData, currentSelection, bettingEndsEventId, events, dropdownOptions, bettingStatus } = state;
    const styles = useDynamicStyles(generateStyles);
    const { fpUser } = useServices();
    let bettingEnds;

    if (bettingEndsEventId > 0) {
        const event = events.find((val) => val.id === bettingEndsEventId);
        if (event) {
            bettingEnds = event.bettingEnds;
        }
    }

    return (
        <View style={[styles.leaderboardContainer, edgeDeploy ? styles.edgeContainer : {}]}>
            <LeaderboardDropdown
                dropdownData={dropdownOptions}
                eventSelected={handleEventSelected}
                value={currentSelection}
            />
            {bettingEnds && Date.parse(bettingEnds) > Date.now() && bettingStatus !== BettingEventStatus.RESULTED ? (
                <View style={styles.container}>
                    <Text style={styles.checkBackLater}>Check back later to see the scores</Text>

                    <CountDownTimer inDate={bettingEnds} />
                </View>
            ) : (
                <Leaderboard TestID={"Leaderboard"} leaderboardData={leaderboardData} playerId={fpUser?.id} />
            )}
        </View>
    );
};
const generateStyles = () => {
    return EStyleSheet.create({
        [MediaQueries.MEDIUM]: {
            edgeContainer: {
                padding: 15,
                borderRadius: 0,
                marginVertical: 0,
            },
            edgeMiddleButton: {
                marginHorizontal: "10px",
                // marginHorizontal: "10px!important",
            },
        },
        [MediaQueries.XSMALL]: {
            edgeContainer: {
                paddingHorizontal: 0,
                paddingVertical: 15,
            },
        },
        edgeContainer: {
            width: "100%",
            maxWidth: 860,
            marginHorizontal: "auto",
            padding: 30,
            marginVertical: 30,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
        },
        leaderboardContainer: {
            flex: 1,
            width: "100%",
            alignItems: "center",
        },
        container: {
            flex: 1,
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
        },
        headerFont: {
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
        checkBackLater: {
            fontSize: 18,
            marginTop: 5,
            fontWeight: "600",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            textAlign: "center",
            marginBottom: 10,
        },
    });
};
